export default "__VITE_ASSET__66ea4cae__"